export enum SigneeTypeRepresentation {
  Natural = "NATURAL",
  Legal = "LEGAL",
}
